import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between" }
const _hoisted_3 = { class: "text-dark order-2 order-md-1" }
const _hoisted_4 = { class: "text-muted fw-bold me-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://jetmedia.io",
  target: "_blank",
  class: "text-gray-800 text-hover-primary"
}, "JetMedia Production Services, LLC", -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<ul class=\"menu menu-gray-500 menu-hover-primary fw-bold order-1\"><li class=\"menu-item\"><a href=\"https://g.stagehub.com/privacy\" target=\"_blank\" class=\"menu-link px-2\">Privacy Policy</a></li><li class=\"menu-item\"><a href=\"https://g.stagehub.com/tos\" target=\"_blank\" class=\"menu-link px-2\">Terms &amp; Conditions</a></li><li class=\"menu-item\"><a href=\"https://g.stagehub.com/support\" target=\"_blank\" class=\"menu-link px-2\">Help Center</a></li></ul>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "©" + _toDisplayString(new Date().getFullYear()), 1),
        _hoisted_5
      ]),
      _hoisted_6
    ])
  ]))
}